export const cancellationPeriodTypeValue = {
  BEFORE_MOVE_IN: 'BEFORE_MOVE_IN',
  UNTIL_MOVE_IN_DAY: 'UNTIL_MOVE_IN_DAY',
  NON_REFUNDABLE: 'NON_REFUNDABLE',
  AFTER_BOOKING_CONFIRMED: 'AFTER_BOOKING_CONFIRMED',
};

export const cancellationPeriodTypeOptions = [
  {
    value: cancellationPeriodTypeValue.BEFORE_MOVE_IN,
    text: 'cms.properties.edit.detail.cancellation_period.before_move_in',
  },
  {
    value: cancellationPeriodTypeValue.UNTIL_MOVE_IN_DAY,
    text: 'cms.properties.edit.detail.cancellation_period.until_move_in_day',
  },
  {
    value: cancellationPeriodTypeValue.NON_REFUNDABLE,
    text: 'cms.properties.edit.detail.cancellation_period.non_refundable',
  },
  {
    value: cancellationPeriodTypeValue.AFTER_BOOKING_CONFIRMED,
    text: 'cms.properties.edit.detail.cancellation_period.after_booking_confirmed',
  },
];

export const billingCycleOptions = [
  { value: 'DAYLY', text: 'cms.properties.edit.detail.billing_cycle.option_day' },
  { value: 'WEEKLY', text: 'cms.properties.edit.detail.billing_cycle.option_week' },
  { value: 'MONTHLY', text: 'cms.properties.edit.detail.billing_cycle.option_month' },
];

export const typeOptions = [
  { value: 'student-accommodation', text: 'cms.properties.edit.detail.type.student-accommodation' },
  { value: 'multi-family', text: 'cms.properties.edit.detail.type.multi-family' },
  { value: 'long-tail', text: 'cms.properties.edit.detail.type.long-tail' },
  { value: 'hotel', text: 'cms.properties.edit.detail.type.hotel' },
  { value: 'serviced-apartment', text: 'cms.properties.edit.detail.type.serviced-apartment' },
  { value: 'real-estate-agent', text: 'cms.properties.edit.detail.type.real-estate-agent' },
];

export const rankTypeOptions = [
  { value: 'NORMAL', text: 'cms.properties.edit.tab_label.others.ranking_type_normal' },
  { value: 'STAR', text: 'cms.properties.edit.tab_label.others.ranking_type_star' },
  { value: 'BLACKSHEEP', text: 'cms.properties.edit.tab_label.others.ranking_type_black_sheep' },
];

export const paymentObject = {
  PayToLandlord: 'PAY_TO_LANDLORD',
  PayToStudentCom: 'PAY_TO_STUDENT_COM',
};

export const paymentObjectOptions = [
  {
    value: paymentObject.PayToLandlord,
    text: 'cms.deposit_and_fees.deposit_modal.payment_object.option.pay_to_landlord',
  },
  {
    value: paymentObject.PayToStudentCom,
    text: 'cms.deposit_and_fees.deposit_modal.payment_object.option.pay_to_student_com',
  },
];

export const displayLocaleOptions = [
  {
    name: 'English',
    value: 'en-us',
  },
  {
    name: '简体中文',
    value: 'zh-cn',
  },
  {
    name: '繁體中文',
    value: 'zh-hk',
  },
  {
    name: '한국어',
    value: 'ko-kr',
  },
  {
    name: '日本語',
    value: 'ja-jp',
  },
  {
    name: 'ภาษาไทย',
    value: 'th-th',
  },
  {
    name: 'Tiếng Việt',
    value: 'vi-vn',
  },
  {
    name: 'Deutsch',
    value: 'de-de',
  },
  {
    name: 'Ελληνικά',
    value: 'el-gr',
  },
  {
    name: 'Español',
    value: 'es-es',
  },
  {
    name: 'Français',
    value: 'fr-fr',
  },
  {
    name: 'Italiano',
    value: 'it-it',
  },
];

export const rankingOptions = [
  {
    name: 'By Default',
    value: 'BY_DEFAULT',
  },
  {
    name: 'First place',
    value: 'FIRST_PLACE',
  },
  {
    name: 'Second place',
    value: 'SECOND_PLACE',
  },
  {
    name: '3rd place',
    value: 'THIRD_PLACE',
  },
  {
    name: '4th place',
    value: 'FOURTH_PLACE',
  },
  {
    name: '5th place',
    value: 'FIFTH_PLACE',
  },
  {
    name: '6th place',
    value: 'SIXTH_PLACE',
  },
  {
    name: '7th place',
    value: 'SEVENTH_PLACE',
  },
  {
    name: '8th place',
    value: 'EIGHTH_PLACE',
  },
];
